<template>
	<div id="app">
		
		<navbar :to="'/cinema'"></navbar>
		<div class="containner mt-30 flex item-start justify-between" v-if="$store.getters.watchtime.film">
			
			<div class="round-left px-5 py-20 rounded box-shadow">
				
				<div class="flex justify-center item-center">
					<div class="mx-20 flex item-center">
						<img src="../assets/seat01.png"/>
						<div class="ml-10 text-lg gray">可选座位</div>
					</div>
					<div class="mx-20 flex item-center">
						<img src="../assets/seat02.png"/>
						<div class="ml-10 text-lg gray">已售座位</div>
					</div>
					<div class="mx-20 flex item-center">
						<img src="../assets/seat03.png"/>
						<div class="ml-10 text-lg gray">已选座位</div>
					</div>
					<div class="mx-20 flex item-center">
						<img src="../assets/seat04.png"/>
						<div class="ml-10 text-lg gray">情侣座位</div>
					</div>
				</div>
			
				<div class="mt-20 flex justify-center">
					<img src="../assets/monitor.png"/>
				</div>
				<div class="mt-10 gray text-xl bold">荧幕位置</div>

				<div class="mt-30 text-md gray bold" v-if="$store.getters.watchtime.wtCostSitesList">
					<div class="my-5 flex justify-between item-center"
						v-for="(row,row_index) of $store.getters.watchtime.wtCostSitesList"
						:key="'seat-row-'+row.row">
						<div class="w-5">{{row_index+1}}</div>
						<div class="w-95 flex justify-center item-center">
							<template v-for="(seat,col_index) of row.colums"
								:key="'seat-'+row_index+'-'+col_index">
								<div v-if="!seat.site_no" class="seat-empty mx-5"></div>
								<img v-else-if="seat.site_state == 1" src="../assets/seat01.png" class="mx-5 hand" @click="seat_checked(seat)"/>
								<img v-else-if="seat.site_state == 2" src="../assets/seat02.png" class="mx-5"/>
								<img v-else-if="seat.site_state == 3" src="../assets/seat03.png" class="mx-5 hand" @click="seat_unchecked(seat)"/>
								<!-- <img v-else-if="seat.site_state == 4" src="../assets/seat04.png" class="mx-5 hand"/> -->
							</template>
							
						</div>
					</div>
				</div>

			</div>

			<div class="round-right px-20 py-20 rounded box-shadow text-left">
				<div class="flex item-start">
					<img :src="'http://124.222.209.62/atstudy-cateye/imgs/film_avat/'+$store.getters.watchtime.film.filmAvat" class="w-40 rounded"/>
					<div class="ml-10">
						<div class="text-lg bold dark">{{$store.getters.watchtime.film.filmName}}</div>
						<div class="mt-5 text-sm gray">
							{{$store.getters.watchtime.film.filmCateKeyword}}
						</div>
						<div class="mt-5 text-sm gray">{{$store.getters.watchtime.film.filmTimelong=='0'?'100':$store.getters.watchtime.film.filmTimelong}}分钟</div>
						<div class="mt-10 text-md dark">{{$store.getters.watchtime.cinema.cmaName}}</div>
						<div class="mt-5 text-sm gray flex">
							<div>{{$store.getters.watchtime.watchTimes.wtHalls}}</div>
							<div class="ml-5">{{$store.getters.watchtime.watchTimes.wtVersion}}</div>
						</div>
						<div class="mt-5 text-sm red flex">
							<div>{{$store.getters.watchtime.watchTimes.wdDate}}</div>
							<div class="ml-5">{{$store.getters.watchtime.watchTimes.wtBegintime}}</div>
							<div class="ml-5">{{$store.getters.watchtime.watchTimes.wtEndtime}}</div>
						</div>
					</div>
				</div>
				<div class="flex item-end text-left py-20 border-bottom">
					<div class="text-sm gray">票价：</div>
					<div class="red text-xl weight">{{$store.getters.watchtime.watchTimes.wtCost}}</div>
					<div class="red text-sm ml-5">元</div>
					<div class="gray text-sm ml-5">（一次最多选{{$store.getters.watchtime.watchTimes.wtMaxsel}}个座位）</div>
				</div>
				<div class="py-20 flex item-start text-sm border-bottom">
					<div class="gray my-10 w-15">座位：</div>
					<div class="flex item-start wrap w-85">
						<div class="tickets red mx-5 my-5"
							v-for="seat of selected_sites"
							:key="'ticket-'+seat.site_no">{{seat.site_row}}排{{seat.site_colum}}座</div>
					</div>
				</div>
				<div class="flex item-end text-left py-20 border-bottom">
					<div class="text-sm gray">总价：</div>
					<div class="red text-xl weight">{{($store.getters.watchtime.watchTimes.wtCost * this.selected_sites.length).toFixed(1)}}</div>
					<div class="red text-sm ml-5">元</div>
				</div>
				<div class="mt-20 flex justify-center">
					<input type="text" class="ticket-input w-100" placeholder="输入手机号"/>
				</div>
				<div class="mt-20 flex justify-center">
					<input type="text" class="ticket-input w-100" placeholder="填写验证码"/>
				</div>
				<div class="mt-20 flex justify-center">
					<button class="ticket-btn hand w-100">确认选座</button>
				</div>
			</div>
			
		</div>
		
		
		<!--  页脚  -->
		<foot></foot>
		<!--  /页脚  -->
	</div>
</template>

<script>
	import navbar from '@/components/navbar.vue'
	import foot from '@/components/foot.vue'
	export default {
		data () {
			return {
				selected_sites: []
			} 
		},
		components:{
			navbar,
			foot
		},
		methods: {
			seat_checked (seat) {
				if(this.selected_sites.length == this.$store.getters.watchtime.watchTimes.wtMaxsel){
					// alert('最多只能买'+$store.getters.watchtime.watchTimes.wtMaxsel+'票')
					return true
				}
				this.selected_sites.push(seat)
				seat.site_state = '3'
			},
			seat_unchecked (seat) {
				let del_flag = 0
				for (let item of this.selected_sites) {
					if (seat.site_no == item.site_no) {
						del_flag = this.selected_sites.indexOf(item)
					}
				}
				this.selected_sites.splice(del_flag, 1)
				seat.site_state = '1'
			}
		},
		mounted () {
			this.$store.dispatch('actWatchTimeLoad', {
				payload: {
					filmId: this.$route.query.filmId,
					watchId: this.$route.query.watchId,
				}
			})
		}
	}
</script>

<style>
	.btn-round-buy{padding: 10px 20px; outline: none; background-color: #C11; color: #fff; border: 0px; border-radius: 6px;}
	.btn-round-buy:hover{background-color: #E1251B;}
	.round-left{width: 860px;}
	.round-right{width: 270px;}
	.seat-empty{width: 30px;}
	.tickets{padding: 4px 8px; border: 1px solid #e33; border-radius: 2px;}
	.ticket-input{outline: none; padding: 9px 20px; border: 1px solid #ccc; border-radius: 10px;}
	.ticket-btn{outline: none; padding: 10px 20px; border: 0px;  border-radius: 10px; color: #fff; background-color: #d33;}
	.ticket-btn:hover{background-color:#f33;}
</style>
